var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay10Up(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 31 31",
    className: "s3m9f13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.678,
    cy: 15.212,
    r: 15,
    fill: "#F3F9FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A819F",
    d: "m23.677 15.712-12.75 7.361V8.351l12.75 7.361Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay10Up);
export default __webpack_public_path__ + "static/media/play10up.dbe6b009006a4b2fe8b5fd82e7e9936d.svg";
export { ForwardRef as ReactComponent };